import { BUSCAR_MAPAS_VEICULOS } from '../../actions/types'

const initialState = undefined

export default function reducerMapasVeiculos (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_MAPAS_VEICULOS: {
      const mapas = action.payload.data;

      if (mapas) {
        return mapas
      }
      return []
    }

    default: {
      return state
    }
  }
}
